module.exports = __webpack_public_path__ + "media/images/compass-359a2bf9ee5385330112714912c75122.svg";